import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminLayout from "../../../layouts/AdminLayout";
import Loader from "../../../components/loader";
import TableHeader from "../../../components/table/tableHeader";
import PaginationDropdown from "../../../components/table/PaginationDropdown";
import ReactPagination from "../../../components/table/ReactPagination";
import AdminTicketDetails from "../../../components/pages/admin/modals/AdminTicketDetails";
import { fetchAdminTickets } from "../../../redux/features/admin/actions/authAction";

const SupportTicket = () => {
  const dispatch = useDispatch();
  const { isLoading, adminTicketList } = useSelector(
    (state) => state.admin.auth
  );

  const [currentPage, setCurrentPage] = useState(0);
  const [listPerPages, setListPerPages] = useState(5);
  const [activeTicket, setActiveTicket] = useState(null);

  useEffect(() => {
    dispatch(fetchAdminTickets());
  }, [dispatch]);

  useEffect(() => {
    setCurrentPage(0);
  }, [adminTicketList, listPerPages]);

  const paginatedList =
    adminTicketList?.slice(
      currentPage * listPerPages,
      (currentPage + 1) * listPerPages
    ) || [];

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <AdminLayout>
      <div className="ct_px_40 mt-4">
        <div className="mb-4 d-flex align-items-center gap-3 justify-content-between ct_flex_col_1199">
          <div>
            <h4 className="mb-0 ct_fs_20">Support Tickets</h4>
            <p className="ct_grey_text mb-0">
              Review support tickets from freelancers and enterprises
            </p>
          </div>
        </div>

        <div className="ct_custom_table ct_custom_table2">
          <div className="table-responsive">
            <table className="table">
              <TableHeader
                data={["#", "User", "Title", "Category", "Action"]}
              />
              {paginatedList?.length > 0 && (
                <tbody>
                  {paginatedList.map((ticket, index) => {
                    const fullName =
                      ticket?.ticket_user_full_name ||
                      `${ticket?.ticket_user_first_name || ""} ${ticket?.ticket_user_last_name || ""
                        }`.trim() ||
                      "#N/A";
                    return (
                      <tr key={ticket?.ticket_id || index}>
                        <td>{currentPage * listPerPages + index + 1}</td>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <img
                              src={
                                ticket?.ticket_user_profile_image ||
                                "/assets/img/user_profile.png"
                              }
                              className="ct_img_30"
                            />
                            <div>
                              <p className="mb-0 ct_fw_600">{fullName}</p>
                              <p className="mb-0 ct_fs_12 ct_grey_text">
                                {ticket?.ticket_user_email || "#N/A"}
                              </p>
                            </div>
                          </div>
                        </td>
                        <td className="text-capitalize">
                          {ticket?.title || "#N/A"}
                        </td>
                        <td>{ticket?.category || "#N/A"}</td>
                        <td>
                          <i
                            className="fa-solid fa-eye"
                            style={{ cursor: "pointer" }}
                            onClick={() => setActiveTicket(ticket)}
                          ></i>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              )}
            </table>
            {paginatedList?.length <= 0 && (
              <div className="text-center ct_grey_text py-4">
                No tickets found.
              </div>
            )}
          </div>
          {adminTicketList?.length > 0 && (
            <div className="d-flex justify-content-between align-items-center mt-4 ">
              <div>
                <PaginationDropdown
                  onChange={(val) => {
                    setListPerPages(val);
                    setCurrentPage(0);
                  }}
                />
              </div>
              <div>
                <ReactPagination
                  pageCount={Math.ceil(
                    (adminTicketList?.length || 0) / listPerPages
                  )}
                  onPageChange={handlePageClick}
                  currentPage={currentPage}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      {activeTicket && (
        <AdminTicketDetails
          isModal={!!activeTicket}
          setIsModal={() => setActiveTicket(null)}
          ticket={activeTicket}
        />
      )}
    </AdminLayout>
  );
};

export default SupportTicket;
